/*
 * CHERRY theme - client-side filters + sort for sections/pepper-main-collection.liquid (Pepper collection layout).
 * Every product of the collection is in the grid with its values in data attributes (data-size, data-usize, data-band,
 * data-cup, data-ptype, data-color = "Name::css|..."). OR inside a group, AND between groups; options that would give
 * 0 results with the other active groups are hidden (as on Pepper). State lives in the URL (?size=32A,34A&color=Black).
 * Sort: price / title / date are sorted in place; "featured" and "best selling" reload the page with sort_by.
 */
(function () {
  var CUPS = ['AA', 'A', 'B', 'C', 'D', 'DD'];
  var LETTERS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '1X', '2X', '3X', 'OS', 'ONE SIZE'];
  var CHECK = '<svg viewBox="0 0 10 8" aria-hidden="true"><path d="M1 4l3 3 5-6" fill="none" stroke="#fff" stroke-width="1.6"/></svg>';
  var CHEVRON = '<svg viewBox="0 0 12 8" aria-hidden="true"><path d="M1 6.5l5-5 5 5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';
  var CROSS = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.6"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function split(v) { return (v || '').split('|').filter(Boolean); }
  function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function braKey(v) { var m = /^(\d+)(.*)$/.exec(v); return m ? (+m[1]) * 10 + CUPS.indexOf(m[2]) : 9999; }
  function letterKey(v) { var i = LETTERS.indexOf(v.toUpperCase()); return i < 0 ? 100 : i; }

  // group id, label, facet sub-labels, layout
  var GROUPS = [
    { id: 'size', label: 'Size', facets: [{ key: 'size', label: 'Bra Size', sort: function (a, b) { return braKey(a) - braKey(b); } }, { key: 'usize', label: 'Underwear Size', sort: function (a, b) { return letterKey(a) - letterKey(b) || a.localeCompare(b); } }], layout: 'square' },
    { id: 'band', label: 'Band Size', facets: [{ key: 'band', sort: function (a, b) { return +a - +b; } }], layout: 'square' },
    { id: 'cup', label: 'Cup Size', facets: [{ key: 'cup', sort: function (a, b) { return CUPS.indexOf(a) - CUPS.indexOf(b); } }], layout: 'square' },
    { id: 'ptype', label: 'Product Type', facets: [{ key: 'ptype', sort: null }], layout: 'check' },
    { id: 'color', label: 'Colors', facets: [{ key: 'color', sort: null }], layout: 'circle' }
  ];
  var KEYS = ['size', 'usize', 'band', 'cup', 'ptype', 'color'];
  var LABELS = { size: 'Size', usize: 'Size', band: 'Band', cup: 'Cup', ptype: '', color: '' };

  function init(root) {
    var grid = root.querySelector('[data-pcl-grid]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-pcl-item]'));
    var side = root.querySelector('[data-pcl-side]');
    var groupsEl = root.querySelector('[data-pcl-groups]');
    var chipsEl = root.querySelector('[data-pcl-chips]');
    var pillsEl = root.querySelector('[data-pcl-pills]');
    var countEls = root.querySelectorAll('[data-pcl-count]');
    var emptyEl = root.querySelector('[data-pcl-empty]');
    var openBtn = root.querySelector('[data-pcl-open]');
    var footBtn = root.querySelector('.pcl-foot__btn');
    var sortEl = root.querySelector('[data-pcl-sort]');
    var serverSort = root.getAttribute('data-server-sort') || '';
    var swatchBg = {};

    // product values
    var data = items.map(function (el) {
      var d = { el: el };
      KEYS.forEach(function (k) {
        if (k === 'color') {
          d.color = split(el.getAttribute('data-color')).map(function (pair) {
            var p = pair.split('::');
            if (!swatchBg[p[0]]) swatchBg[p[0]] = p[1] || '';
            return p[0];
          });
        } else if (k === 'ptype') {
          d.ptype = el.getAttribute('data-ptype') ? [el.getAttribute('data-ptype')] : [];
        } else {
          d[k] = uniq(split(el.getAttribute('data-' + k)));
        }
      });
      return d;
    });

    // available values per key (in order of appearance, then sorted)
    var values = {};
    KEYS.forEach(function (k) {
      var all = [];
      data.forEach(function (d) { d[k].forEach(function (v) { if (all.indexOf(v) < 0) all.push(v); }); });
      values[k] = all;
    });
    GROUPS.forEach(function (g) { g.facets.forEach(function (f) { if (f.sort) values[f.key].sort(f.sort); }); });

    // state from URL
    var state = {};
    var params = new URLSearchParams(location.search);
    var initialSort = params.get('sort_by');
    KEYS.forEach(function (k) {
      state[k] = (params.get(k) || '').split(',').map(function (v) { return v.trim(); }).filter(function (v) { return v && values[k].indexOf(v) >= 0; });
    });

    // build the groups
    if (groupsEl) {
      var html = '';
      GROUPS.forEach(function (g, gi) {
        var facets = g.facets.filter(function (f) { return values[f.key].length > 0; });
        if (!facets.length) return;
        html += '<div class="pcl-group" data-group="' + g.id + '">' +
          '<button type="button" class="pcl-group__toggle" aria-expanded="true" aria-controls="pcl-g-' + g.id + '"><span>' + esc(g.label) + '</span>' + CHEVRON + '</button>' +
          '<div class="pcl-group__body" id="pcl-g-' + g.id + '"><div class="pcl-group__inner">';
        facets.forEach(function (f) {
          html += '<div class="pcl-facet">';
          if (f.label && (facets.length > 1 || g.id === 'size')) html += '<p class="pcl-facet__label">' + esc(f.label) + '</p>';
          html += '<div class="pcl-opts pcl-opts--' + g.layout + '">';
          values[f.key].forEach(function (v) {
            var attrs = ' type="button" class="pcl-opt" data-key="' + f.key + '" data-value="' + esc(v) + '" aria-pressed="false"';
            if (g.layout === 'circle') {
              html += '<button' + attrs + ' title="' + esc(v) + '" aria-label="' + esc(v) + '"><span style="background:' + esc(swatchBg[v] || '#fff') + '"></span></button>';
            } else if (g.layout === 'check') {
              html += '<button' + attrs + '><span class="pcl-opt__box">' + CHECK + '</span><span>' + esc(v) + '</span></button>';
            } else {
              html += '<button' + attrs + ' aria-label="' + esc((LABELS[f.key] ? LABELS[f.key] + ' ' : '') + v) + '">' + esc(v) + '</button>';
            }
          });
          html += '</div></div>';
        });
        html += '</div></div></div>';
      });
      groupsEl.innerHTML = html;
    }
    var optEls = groupsEl ? Array.prototype.slice.call(groupsEl.querySelectorAll('.pcl-opt')) : [];

    function matches(d, skipKey) {
      for (var i = 0; i < KEYS.length; i++) {
        var k = KEYS[i];
        if (k === skipKey || !state[k].length) continue;
        // Bra size and underwear size are one "Size" group: a product passes if it has any selected size of either kind
        if (k === 'size' || k === 'usize') {
          if (skipKey === 'size' || skipKey === 'usize') continue;
          var sel = state.size.concat(state.usize);
          var has = sel.some(function (v) { return d.size.indexOf(v) >= 0 || d.usize.indexOf(v) >= 0; });
          if (!has) return false;
          continue;
        }
        if (!state[k].some(function (v) { return d[k].indexOf(v) >= 0; })) return false;
      }
      return true;
    }

    function activeCount() { return KEYS.reduce(function (n, k) { return n + state[k].length; }, 0); }

    function sortItems(value) {
      var by = null;
      if (value === 'price-ascending') by = function (a, b) { return a.p - b.p; };
      else if (value === 'price-descending') by = function (a, b) { return b.p - a.p; };
      else if (value === 'title-ascending') by = function (a, b) { return a.t.localeCompare(b.t); };
      else if (value === 'title-descending') by = function (a, b) { return b.t.localeCompare(a.t); };
      else if (value === 'created-ascending') by = function (a, b) { return a.c - b.c; };
      else if (value === 'created-descending') by = function (a, b) { return b.c - a.c; };
      var rows = items.map(function (el) {
        return { el: el, i: +el.getAttribute('data-index'), p: +el.getAttribute('data-price'), t: el.getAttribute('data-title') || '', c: +el.getAttribute('data-created') };
      });
      rows.sort(function (a, b) { return (by ? by(a, b) : 0) || a.i - b.i; });
      rows.forEach(function (r) { grid.appendChild(r.el); });
    }

    function syncUrl() {
      var p = new URLSearchParams(location.search);
      KEYS.forEach(function (k) { if (state[k].length) p.set(k, state[k].join(',')); else p.delete(k); });
      if (sortEl) { if (sortEl.value && (sortEl.value !== serverSort || initialSort)) p.set('sort_by', sortEl.value); else p.delete('sort_by'); }
      var q = p.toString().replace(/%2C/g, ',');
      history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + location.hash);
    }

    // show the selected colour on the card when a colour is filtered
    function swapCardColors() {
      if (!state.color.length) return;
      data.forEach(function (d) {
        if (d.el.hidden) return;
        var active = d.el.querySelector('.pph-swatch.is-active');
        if (active && state.color.indexOf(active.getAttribute('title')) >= 0) return;
        var sw = Array.prototype.slice.call(d.el.querySelectorAll('.pph-swatch')).filter(function (b) { return state.color.indexOf(b.getAttribute('title')) >= 0; })[0];
        if (sw) selectSwatch(sw);
      });
    }

    function render() {
      var visible = 0;
      data.forEach(function (d) {
        var ok = matches(d, null);
        d.el.hidden = !ok;
        if (ok) visible++;
      });
      var label = visible + (visible === 1 ? ' item' : ' items');
      Array.prototype.forEach.call(countEls, function (el) { el.textContent = label; });
      if (footBtn) footBtn.textContent = 'Show results (' + visible + ')';
      if (emptyEl) emptyEl.hidden = visible > 0;

      // options: pressed state + hide the ones that give no result with the other groups
      optEls.forEach(function (b) {
        var k = b.getAttribute('data-key'), v = b.getAttribute('data-value');
        var on = state[k].indexOf(v) >= 0;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) { b.hidden = false; return; }
        var n = 0;
        for (var i = 0; i < data.length; i++) { if (data[i][k].indexOf(v) >= 0 && matches(data[i], k)) { n = 1; break; } }
        b.hidden = n === 0;
      });
      if (groupsEl) {
        Array.prototype.forEach.call(groupsEl.querySelectorAll('.pcl-facet'), function (f) {
          f.hidden = !f.querySelector('.pcl-opt:not([hidden])');
        });
        Array.prototype.forEach.call(groupsEl.querySelectorAll('.pcl-group'), function (g) {
          g.hidden = !g.querySelector('.pcl-facet:not([hidden])');
        });
      }

      // chips (sidebar) + mobile pills
      var chips = '';
      KEYS.forEach(function (k) {
        state[k].forEach(function (v) {
          chips += '<button type="button" class="pcl-chip" data-remove-key="' + k + '" data-remove-value="' + esc(v) + '" aria-label="Remove ' + esc(v) + '">' + esc((LABELS[k] && (k === 'band' || k === 'cup') ? LABELS[k] + ' ' : '') + v) + CROSS + '</button>';
        });
      });
      if (chipsEl) {
        chipsEl.hidden = !chips;
        chipsEl.innerHTML = chips ? chips + '<button type="button" class="pcl-clear" data-pcl-clear>Clear</button>' : '';
      }
      if (pillsEl) {
        if (chips) {
          pillsEl.innerHTML = chips.replace(/pcl-chip/g, 'pcl-pill') + '<button type="button" class="pcl-pill" data-pcl-clear>Clear all</button>';
        } else {
          var pills = '';
          GROUPS.forEach(function (g) {
            if (groupsEl && groupsEl.querySelector('.pcl-group[data-group="' + g.id + '"]:not([hidden])')) pills += '<button type="button" class="pcl-pill" data-open-group="' + g.id + '">' + esc(g.label) + '</button>';
          });
          pillsEl.innerHTML = pills;
        }
      }
      if (openBtn) openBtn.classList.toggle('is-active', activeCount() > 0);
      swapCardColors();
    }

    function toggle(k, v) {
      var i = state[k].indexOf(v);
      if (i >= 0) state[k].splice(i, 1); else state[k].push(v);
      render();
      syncUrl();
    }
    function clearAll() { KEYS.forEach(function (k) { state[k] = []; }); render(); syncUrl(); }

    function openPanel(groupId) {
      if (!side) return;
      side.classList.add('is-open');
      document.documentElement.classList.add('pcl-lock');
      if (groupId) {
        var g = groupsEl.querySelector('.pcl-group[data-group="' + groupId + '"]');
        if (g) {
          var t = g.querySelector('.pcl-group__toggle');
          t.setAttribute('aria-expanded', 'true');
          setTimeout(function () { groupsEl.scrollTop += g.getBoundingClientRect().top - groupsEl.getBoundingClientRect().top; }, 350);
        }
      }
    }
    function closePanel() {
      if (!side) return;
      side.classList.remove('is-open');
      document.documentElement.classList.remove('pcl-lock');
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var opt = t.closest('.pcl-opt');
      if (opt) { toggle(opt.getAttribute('data-key'), opt.getAttribute('data-value')); return; }
      var rm = t.closest('[data-remove-key]');
      if (rm) { toggle(rm.getAttribute('data-remove-key'), rm.getAttribute('data-remove-value')); return; }
      if (t.closest('[data-pcl-clear]')) { clearAll(); return; }
      var tg = t.closest('.pcl-group__toggle');
      if (tg) { tg.setAttribute('aria-expanded', tg.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'); return; }
      var og = t.closest('[data-open-group]');
      if (og) { openPanel(og.getAttribute('data-open-group')); return; }
      if (t.closest('[data-pcl-open]')) { openPanel(); return; }
      if (t.closest('[data-pcl-close]')) { closePanel(); return; }
      var sw = t.closest('.pph-swatch');
      if (sw) selectSwatch(sw);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });

    if (sortEl) {
      sortEl.addEventListener('change', function () {
        var v = sortEl.value;
        var clientSide = /^(price|title|created)-/.test(v);
        if (v === serverSort) { sortItems(null); syncUrl(); return; }
        if (clientSide) { sortItems(v); syncUrl(); return; }
        var p = new URLSearchParams(location.search);
        p.set('sort_by', v);
        location.search = p.toString().replace(/%2C/g, ',');
      });
    }

    render();
  }

  // card swatches (same behaviour as the homepage cards)
  function selectSwatch(sw) {
    var card = sw.closest('[data-pph-card]');
    if (!card) return;
    card.querySelectorAll('.pph-swatch').forEach(function (b) {
      b.classList.toggle('is-active', b === sw);
      b.setAttribute('aria-checked', b === sw ? 'true' : 'false');
    });
    var img = card.querySelector('.pph-img-1');
    if (img && sw.dataset.pphSrc) { img.srcset = sw.dataset.pphSrcset; img.src = sw.dataset.pphSrc; }
    card.classList.add('is-swapped');
    card.querySelectorAll('[data-pph-link]').forEach(function (a) { if (sw.dataset.pphUrl) a.href = sw.dataset.pphUrl; });
  }

  function boot() { document.querySelectorAll('[data-pcl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-pcl]'); if (r) init(r); });
})();
